import React from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { CARD_TYPES } from '../../../shared/constants';
import { IImage } from '../../../types/shared';

import { ProductPageH2 } from '../../../styles/generic';

interface Props {
  title: string;
  image: IImage;
}

const ImageOrVideoCard = ({ title, image }: Props) => (
  <ImageOrVideoCardContainer id={CARD_TYPES.imageOrVideoOnly}>
    <StyledH2>{title}</StyledH2>
    <VisualContainer>
      {image.gatsbyImageData ? (
        <GatsbyImage alt="" image={image.gatsbyImageData as IGatsbyImageData} />
      ) : (
        image.file && <StyledImage src={image.file.url} alt="" />
      )}
    </VisualContainer>
  </ImageOrVideoCardContainer>
);

export default ImageOrVideoCard;

const StyledH2 = styled(ProductPageH2)`
  margin: 0 0 8px 0;
  text-align: center;
`;

const VisualContainer = styled.div`
  width: inherit;
`;

const ImageOrVideoCardContainer = styled.div`
  width: 100%;
`;

const StyledImage = styled.img`
  width: inherit;
`;
